import { getAnnualReviewDetailUrl, getAnnualReviewEditUrl } from 'bank-annual-review/src/Routes/AnnualReview/route'
import { AnnualReviews } from 'commons/types/DTO/bank/alerts/annualReviews'
import { DateTime } from 'ui/components/DateTime'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

export const columns = (): TableColumn<AnnualReviews>[] => [
  {
    title: 'Annual Review Number',
    align: 'center',
    render: (item) => (
      <Link to={getAnnualReviewDetailUrl({ id: item.id, companyId: item.companyID })}>{item.number}</Link>
    )
  },
  {
    title: 'Company',
    align: 'left',
    render: (item) => (
      <>
        <Link to="/relationships/$id" params={{ id: item.companyID.toString() }}>
          {item.company}
        </Link>
        <div>{item.companyPhone}</div>
        <div>{item.companyFax}</div>
      </>
    )
  },
  {
    title: 'Financials Date',
    align: 'center',
    key: 'financialsDate'
  },
  {
    title: 'Status',
    align: 'center',
    key: 'status'
  },
  {
    title: 'Date Completed',
    align: 'center',
    render: ({ dateCompleted }) => dateCompleted || '---'
  },
  {
    title: 'Created Date',
    align: 'center',
    render: ({ createdDate }) => createdDate && <DateTime date={createdDate} withTime />
  },
  {
    title: 'Action',
    align: 'center',
    render: (item) => (
      <TableActions
        items={[
          ...(item.enableNew
            ? [
                {
                  title: item.actionName,
                  type: 'option' as const,
                  url: getAnnualReviewEditUrl({ id: item.id, companyId: item.companyID })
                }
              ]
            : []),
          ...(item.enableApprove
            ? [
                {
                  title: 'Approve',
                  type: 'option' as const,
                  url: getAnnualReviewDetailUrl({ id: item.id, companyId: item.companyID })
                }
              ]
            : []),
          ...(item.enableEdit
            ? [
                {
                  type: 'edit' as const,
                  url: getAnnualReviewEditUrl({ id: item.id, companyId: item.companyID })
                }
              ]
            : [])
        ]}
      />
    )
  }
]
